// =============================================================================
// app/src/componentes/BotaoJogo.tsx — o jogo completo, num toque (08/10/2026).
//
// Pedido do dono: "queria que quando o cara colocasse uma calota desse a
// oportunidade de clicar em um botão que aparece JOGO em que ele clica e coloca
// 4 unidades".
//
// Ele existe por causa da mudança do mesmo dia: a calota deixou de ser vendida
// em jogo e passou a ser vendida por peça (estoque × 4, preço ÷ 4). A conta do
// cliente não mudou — quatro peças custam o que o jogo custava —, mas agora
// quem leva o jogo depende de o vendedor digitar 4. Se ele deixar 1, a loja
// cobra um quarto, e ninguém percebe até o fim do mês.
//
// Componente separado e SÓ COM PROPS de propósito: é o que o teste consegue
// desenhar sem montar a tela de Vender inteira (o ambiente é node, sem jsdom:
// só o primeiro quadro, nenhum clique).
// =============================================================================
export default function BotaoJogo({ unidades, quantidade, descricao, aoTocar }: {
  /** Quantas peças formam o jogo (4, na calota). */
  unidades: number;
  /** A quantidade que a linha tem agora — é o que desliga o botão quando o
   *  jogo já está montado. */
  quantidade: number;
  /** Para o leitor de tela saber de QUAL linha é este botão: numa venda de
   *  três calotas diferentes haveria três botões iguais. */
  descricao: string;
  aoTocar: () => void;
}) {
  const pronto = quantidade === unidades;
  return (
    <div className="mt-2">
      {/* `min-h-11` (44 px) porque é botão para o DEDO, no balcão, com o
          cliente esperando — a mesma régua do mapa e dos botões de quantidade
          desta tela. E `botao-terciario` é o botão pequeno canônico da casa:
          ele já traz hover e `disabled` resolvidos. */}
      <button type="button" className="botao-terciario min-h-11"
              disabled={pronto}
              onClick={aoTocar}
              aria-label={`Jogo de ${unidades}: ${descricao}`}>
        Jogo ({unidades})
      </button>
      <p className="mt-1 text-xs text-dim">
        {pronto
          ? `o jogo completo está na venda — ${unidades} peças`
          : `o jogo completo são ${unidades} peças`}
      </p>
    </div>
  );
}
